import { HubRoute } from '@/types/hub'
import { extractParts, compareValueWithPrefix } from '@/helpers/compareValueWithPrefix'

export const sortRoutes = (routes: HubRoute[]): HubRoute[] => {
    return routes.sort((routeA, routeB) => {
        const [prefixA, numA, suffixA] = extractParts(routeA.route)
        const [prefixB, numB, suffixB] = extractParts(routeB.route)

        return compareValueWithPrefix([prefixA, numA, suffixA], [prefixB, numB, suffixB])
    })
}
